import React from "react";

export const RuleComponent = (props: {
	rule: () => boolean;
	children: React.ReactNode;
}): React.ReactElement | null => {
	return props.rule() ? <>{props.children}</> : null;
};
